/* eslint-disable */
// ignore regexp lint error
import { load } from '../ws-util';
import util from './util';

const ua = navigator.userAgent || '';
const iPad = ua.match(/(iPad).*OS\s([\d_]+)/);
const iPhone = !iPad && ua.match(/(iPhone).*OS\s([\d_]+)/);
const iPod = ua.match(/(iPod).*OS\s([\d_]+)/);
const android = ua.match(/(Android)\s+([\d.]+)/) || ua.match(/Android/);
const wp = ua.match(/Windows Phone ([\d.]+)/);
const isMobile = iPad || iPhone || iPad || wp || android;
let quaString = (ua.match(/Qzone\/[^ ]*/) && ua.match(/Qzone\/[^ ]*/)[0]) || '';
if (quaString && quaString != '') {
  quaString = quaString.replace('Qzone/', '');
}
// 手Q也来一发
if (!quaString || quaString == '') {
  // 需要输出成V1_IPH_SQ_6.2.2_1_APP_A
  // 先把android的搞出来
  const qqQuaReg = /(V\S+_\S+_\S+_\S+_\S+_\S+_\S+)/;
  quaString = (ua.match(qqQuaReg) && ua.match(qqQuaReg)[1]) || '';
  if (!quaString || quaString == '') {
    // 再把ios的qq版本号转换出来
    quaString = (ua.match(/QQ\/[^ ]*/) && ua.match(/QQ\/[^ ]*/)[0]) || '';
    if (quaString && quaString != '') {
      quaString = quaString.replace('QQ/', '');
      const quaArr = quaString.split('.');
      if (quaArr && quaArr.length == 4) {
        quaString = `V1_IPH_SQ_${quaArr[0]}.${quaArr[1]}.${quaArr[2]}_1_APP_A`;
      } else {
        quaString = '';
      }
    }
  }
}

/**
 * 通过监测游览器UA判断当前平台
 * @class
 */
class HybridBrowser {
  constructor() {
    this.qua = '';
    this.isMobile = !!isMobile;

    let platform = '';
    if (iPhone || iPad || iPod) {
      platform = 'ios';
    } else if (android) {
      platform = 'android';
    } else if (wp) {
      platform = 'wp';
    }
    /**
     * 平台判断
     * @property {String} platform
     */
    this.platform = platform;

    let client = '';
    const isWX = ua.match(/MicroMessenger\/([\d\.]+)/); // 微信
    const isQQEGame = /\bcom\.tencent\.qgame\/([\d\.]+)/.test(ua); // 企鹅电竞
    const isXinYueClub = ua.match('tgclub'); // 心悦俱乐部
    const isQQ = ua.match(/QQ\/([\d\.]+)/); // 手Q
    const isQzone = ua.match('Qzone'); // 手空
    const isQQMusic = /QQMUSIC\/(\d[\.\d]*)/i.test(ua); // qq音乐
    const isFM = ua.match('_FM_'); // 企鹅FM
    const isTencentVideo = ua.match('QQLiveBrowser');
    const isWSInteractiveSdk = ua.match('_WEISHI_INTERACTIVE_H5_SDK_'); // 微视互动h5 sdk
    const isWS = ua.match('_WEISHI_'); // 微视
    const isYYB = /\/qqdownloader\/(\d+)(?:\/(appdetail|external|sdk))?/.test(ua); // 应用宝
    const isKG = ua.match('_KG_'); // K歌
    const isWb = ua.match('Weibo'); // weibo
    const isWeiyun = ua.match(/Weiyun\/(\d\.)+/); // 微云
    const isPITU = ua.match('_PITU_'); // 天天P图，不然就被误认为QQ浏览器了
    const isQQBrowser = ua.match('MQQBrowser') && !isQQEGame && !isXinYueClub; // qq浏览器 (QQEGame,xinYueClub ua里面带有MQQBroswer,所以要加这个判断)
    const isQNReading = ua.match(/qnreading\/([\d\.]*)/i);
    if (isQQ) {
      client = 'qq';
    } else if (isQzone) {
      client = 'qzone';
    } else if (isWX) {
      client = 'wx';
    } else if (isFM) {
      client = 'fm';
    } else if (isQQMusic) {
      client = 'qqmusic';
    } else if (isWSInteractiveSdk) {
      client = 'wsInteractiveSdk';
    } else if (isWS) {
      client = 'ws';
    } else if (isTencentVideo) {
      client = 'tencentVideo';
    } else if (isYYB) {
      client = 'yyb';
    } else if (isWb) {
      client = 'wb';
    } else if (isPITU) {
      client = 'ttpic';
    } else if (isKG) {
      client = 'kg';
    } else if (isWeiyun) {
      client = 'Weiyun';
    } else if (isQQEGame) {
      client = 'QQEGame';
    } else if (isXinYueClub) {
      client = 'xinYueClub';
    } else if (isQQBrowser) { // ！！！最后判断QQBrowser，因为很多app的ua里都带有MQQBrowser！！！
      client = 'QQBrowser';
    } else if (isQNReading) {
      client = 'QNReading';
    }
    /**
     * 主要针对公司几个主要客户端判断
     * @property {String} client
     */
    this.client = client;
    /**
     * 所有平台信息
     * @property {Object} os
     */
    this.os = {
      iPad,
      iPhone,
      android,
      wp,
    };

    /**
     * iOS独立版是否在审核中
     * @property {String} isQzoneReview
     */
    this.isQzoneReview = ua.indexOf('AppstoreReview') >= 0;
  }

  /**
   * get browser 对象，用来与nodejs端的调用保持一致
   */
  getInfo() {
    return this;
  }

  /**
   * 设置quaString
   * @method
   */
  setQuaString(paramsString) {
    quaString = paramsString;
  }

  /**
   * 获取quastring
   * @method
   */
  getQuaString() {
    return quaString;
  }

  /**
   * 获取qua object
   * @method
   */
  getQuaObj() {
    return util.formatQua(quaString);
  }

  /**
   * 获取结合版，独立版版本号，从useragent的qua中获取
   * @method
   */
  getQuaVersion() {
    return this.getQuaObj(quaString).version;
  }

  /**
   * 获取os版本
   */
  getOsVersion() {
    let tmp;
    let ver;
    if (this.platform == 'ios') {
      tmp = ua && ua.match(/OS\s([\d\_\.]+)/);
      if (tmp && tmp[1]) {
        ver = tmp[1].replace(/_/g, '.');
      }
    } else if (this.platform == 'android') {
      tmp = ua && ua.match(/Android[\s\/]+([\d\_\.]+)/);
      if (tmp && tmp[1]) {
        ver = tmp[1].replace(/_/g, '.');
      }
    }
    return {
      platform: this.platform,
      version: ver,
    };
  }

  /**
   * 比较ios和android的系统版本
   * @method
   */
  compareOsVersion(target, cmd) {
    if (!ua) {
      return false;
    }

    let osString = '';
    let matches;
    if (iPhone) {
      matches = ua.match(/(iPhone\sOS)\s([\d_]+)/);
      if (matches.length > 2) {
        osString = matches[2].split('_').join('.');
      } else {
        osString = '';
      }
    } else if (android) {
      matches = ua.match(/(Android)\s+([\d.]+)/);
      if (matches.length > 2) {
        // eslint-disable-next-line prefer-destructuring
        osString = matches[2];
      } else {
        osString = '';
      }
    } else {
      return false;
    }

    // 递归比较数组每一位
    const _compare = function (tokens1, tokens2, p) {
      if (!tokens1[p] && !tokens2[p]) {
        return 0;
      }
      return ((tokens1[p] || 0) - (tokens2[p] || 0)) || _compare(tokens1, tokens2, p + 1);
    };
    let r = _compare(osString.split('.'), (`${target}`).split('.'), 0);
    // eslint-disable-next-line no-nested-ternary
    r = r < 0 ? -1 : r > 0 ? 1 : 0;

    switch (cmd) {
      case 'eq':
        return r === 0;
      case 'neq':
        return r !== 0;
      case 'lt':
        return r < 0;
      case 'nlt':
        return r >= 0;
      case 'gt':
        return r > 0;
      case 'ngt':
        return r <= 0;
      default:
        return r;
    }
  }

  /**
   * 比较客户端版本
   * @method
   */
  compareVersion(target, cmd) {
    // 如果没有quastring直接返回false，不需要再运算了
    if (!quaString) {
      return false;
    }
    const nowVersionInt = +this.getQuaVersion().replace('.', '');

    const targetVersionInt = +`${target}`.replace('.', ''); // 这里需要兼容target为数字的情况；

    switch (cmd) {
      case 'eq':
        return nowVersionInt === targetVersionInt;
      case 'neq':
        return nowVersionInt !== targetVersionInt;
      case 'lt':
        return nowVersionInt < targetVersionInt;
      case 'nlt':
        return nowVersionInt >= targetVersionInt;
      case 'gt':
        return nowVersionInt > targetVersionInt;
      case 'ngt':
        return nowVersionInt <= targetVersionInt;
      default: return false;
    }
  }

  /**
   * 设置qua
   * @private
   */
  sendQua(val, defer, timeout) {
    clearTimeout(timeout);
    this.qua = val;
    defer.resolve(val);
  }

  /**
   * 获取qua
   */
  getQua() {
    return new Promise((resolve) => {
      if (this.qua) {
        resolve(this.qua);
      } else {
        const that = this;
        const timeout = setTimeout(() => {
          clearTimeout(timeout);
          that.qua = '';
          resolve('');
        }, 1000);

        if (this.client === 'qzone') {
          if (quaString) {
            clearTimeout(timeout);
            that.qua = quaString;
            resolve(quaString);
          } else if (window.QZAppExternal) {
            window.QZAppExternal.getQUA((qua) => {
              clearTimeout(timeout);
              that.qua = qua;
              resolve(qua);
            });
          } else {
            clearTimeout(timeout);
            that.qua = '';
            resolve('');
          }
        } else if (this.client === 'qq') {
          if (this.platform === 'ios') {
            window.QQMusicJSInterface = {
              onRecieve(res) {
                clearTimeout(timeout);
                that.qua = res.data.value;
                resolve(res.data.value);
              },
            };
            try {
              load.loadJs(this.getApiUrl(), (mqq) => {
                // eslint-disable-next-line no-unused-expressions
                mqq && mqq.invoke('QzMusic', 'getQua');
              });
            } catch (e) {
              console.error(e);
            }
          } else {
            clearTimeout(timeout);
            that.qua = quaString;
            resolve(quaString);
          }
        } else {
          clearTimeout(timeout);
          that.qua = '';
          resolve('');
        }
      }
    });
  }

  /**
   * 是否google市场渠道包, 异步判断方法
   * @method
   */
  isGMPackage() {
    return new Promise((resolve) => {
      const isGMPkgFromUrl = !!(window.location.search
        && window.location.search.match(/\bqua=V\S+_\S+_\S+_\S+_+\S+_GM_/i));
      if (quaString && quaString != '') {
        if (quaString.indexOf('_GM_') >= 0 || isGMPkgFromUrl) {
          resolve(true);
        } else {
          resolve(false);
        }
      } else if (ua && ua.match(/10000512/)) {
        // QQ轻聊版，带了这个id就是谷歌市场
        resolve(true);
      } else {
        resolve(isGMPkgFromUrl);
      }
    });
  }

  /**
   * 是否google市场渠道包, 同步判断方法
   * @method
   */
  isGMPackageSync() {
    let result;
    const isGMPkgFromUrl = !!(
      window.location.search
      && window.location.search.match(/\bqua=V\S+_\S+_\S+_\S+_+\S+_GM_/i)
    );
    if (ua && ua.match(/10000512/)) {
      // QQ轻聊版，带了这个id就是谷歌市场
      result = true;
    } else if (quaString && quaString != '') {
      result = quaString.indexOf('_GM_') >= 0 || isGMPkgFromUrl;
    } else {
      result = isGMPkgFromUrl;
    }
    return result;
  }

  /**
   * iOS结合版是否在审核中
   */
  isQQReview() {
    return new Promise((resolve) => {
      const sdkUrl = '//imgcache.gtimg.cn/c/=/ACT/vip_act/act_data/mmqversion.json.js,/club/common/wedgets/mqqvc.js';
      load.loadJs(sdkUrl, () => {
        if (window.MQQIOSVC.check()) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  /**
   * 获取相应版本的jsbridge的url
   */
  getApiUrl() {
    if (this.client === 'qq' || this.client === 'fm') {
      return '//open.mobile.qq.com/sdk/qqapi.js?_bid=152';
    } if (this.client === 'qzone') {
      return '//qzonestyle.gtimg.cn/qzone/phone/m/v4/widget/mobile/jsbridge.js';
    }
    return '';
  }
}

export default new HybridBrowser();
